<div id="search-ahead">
    <mat-form-field appearance="fill">
        <mat-label>Search Organizations</mat-label>
        <input matInput id="search-input" #input (keyup)="onFilter(input.value)" />
    </mat-form-field>
</div>

<div>
    <table
        mat-table
        [dataSource]="accounts()"
        matSort
        [matSortActive]="sortField()"
        [matSortDirection]="sortOrder()"
        matSortDisableClear
        id="full-width-table"
        aria-label="Organizations"
        (matSortChange)="sortChange.emit($event)">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-header-txt">Organization Name</th>
            <td mat-cell *matCellDef="let row" class="cell-txt">{{ row.name }}</td>
        </ng-container>

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-header-txt">Organization ID</th>
            <td mat-cell *matCellDef="let row" class="cell-txt">{{ row.id }}</td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-header-txt">Create Date</th>
            <td mat-cell *matCellDef="let row" class="cell-txt">{{ row.createdAt | date: 'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="updatedAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-header-txt">Last Update Date</th>
            <td mat-cell *matCellDef="let row" class="cell-txt">{{ row.updatedAt | date: 'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="cell-header-txt actions-cell"></th>
            <td mat-cell *matCellDef="let row" class="actions-cell" (click)="$event.stopPropagation()">
                <r1-icon-action kind="edit" label="Edit organization" (action)="editAccount.emit(row)" />
                <r1-icon-action kind="delete" label="Delete organization" (action)="deleteAccount.emit(row)" />
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="row-hover"
            [class.row-selected]="row.id === selectedId()"
            (click)="viewAccount.emit(row)"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">No organizations found.</td>
        </tr>
    </table>

    <mat-paginator
        [length]="totalElements()"
        [pageIndex]="pageIndex()"
        [pageSize]="pageSize()"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageChange.emit($event)" />
</div>
